import { ReduxActionGeneric } from "../actions/types";

export enum DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE {
  SET_PROMISSORY_PRICE = "SET_PROMISSORY_PRICE",
  SET_TRACKING_CODE = "SET_TRACKING_CODE",
  SET_SHOP_INFO = "SET_SHOP_INFO",
  ADD_TRACKING_CODE_TO_SET_PLANED_ORDERS = "ADD_TRACKING_CODE_TO_SET_PLANED_ORDERS",
}

export type DashboardPersistReduxActions = {
  setPromissoryPrice: (
    price: number | string,
  ) => ReduxActionGeneric<typeof DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_PROMISSORY_PRICE, number | string>;
  setTrackingCode: (
    code: string,
  ) => ReduxActionGeneric<typeof DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_TRACKING_CODE, string>;
  setShopInfo: (
    name: string,
    url: string,
  ) => ReduxActionGeneric<typeof DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_SHOP_INFO, { name: string; url: string }>;
  addTrackingCodeToSetPlanedOrders: (
    trackingCode: string,
  ) => ReduxActionGeneric<typeof DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.ADD_TRACKING_CODE_TO_SET_PLANED_ORDERS, string>;
};

type DashboardPersistReduxActionsReturn = ReturnType<DashboardPersistReduxActions[keyof DashboardPersistReduxActions]>;

export interface DashboardPersistReduxState {
  lastUrlWasPage?: string;
  promissoryPrice: number | string;
  trackingCode: string;
  shopInfo: {
    name?: string;
    url?: string;
  };
  setPlanedTrackingCodes: string[];
}

export const initialState: DashboardPersistReduxState = {
  promissoryPrice: 0,
  lastUrlWasPage: undefined,
  trackingCode: "",
  shopInfo: {
    name: undefined,
    url: undefined,
  },
  setPlanedTrackingCodes: [],
};

function DashboardReduxReducer(
  // eslint-disable-next-line default-param-last
  state: DashboardPersistReduxState = initialState,
  action: DashboardPersistReduxActionsReturn,
): DashboardPersistReduxState {
  switch (action.type) {
    case DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_PROMISSORY_PRICE:
      return {
        ...state,
        promissoryPrice: action.payload,
      };
    case DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_TRACKING_CODE:
      return {
        ...state,
        trackingCode: action.payload,
      };

    case DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.SET_SHOP_INFO:
      return {
        ...state,
        shopInfo: action.payload,
      };

    case DASHBOARD_PERSIST_REDUX_ACTIONS_TYPE.ADD_TRACKING_CODE_TO_SET_PLANED_ORDERS:
      return { ...state, setPlanedTrackingCodes: [...state.setPlanedTrackingCodes, action.payload] };

    default:
      return state || initialState;
  }
}

export default DashboardReduxReducer;
